module.exports = __webpack_public_path__ + "static/media/contact-phone-icon.d0c91ca2.svg";